export default {
  planning: {
    header: 'Financial Planning',
    body: `<div class="title-sm">Invest in Your Future</div>
<p>For many, planning early is at the heart of a sound financial future.
At SIG & Associates, we realize the importance of taking the right steps in order to
accomplish not only your short-term fiscal goals, but also your long-term desires for a happy retirement.</p>

<p>With Financial Planning services from SIG & Associates, you can receive helpful
advice from a professional who is committed to assisting you in planning
for a secure and stable future. Our Financial Planning advisors can help you determine:</p>

<ul>
<li>The right retirement plan for your individual and family-oriented needs</li>
<li>How much money you should put away in savings</li>
<li>Whether you currently have the right amount of insurance coverage (including Disability)</li>
<li>How much money you should invest</li>
<li>Whether you’re on track to saving enough for retirement</li>
</ul>

<p>Our specialists can even advise you on Estate Planning and Analysis.
It’s important for most people to know and control what happens to their estate upon their passing.
With the right advice and strategy, you can ensure that the family home stays in the family,
your wills and trusts are properly drawn up, your affairs are properly handled, and much more.</p>

<p>Since each person has their own goals for their financial future and retirement,
SIG & Associates is committed to educating you on making the right decisions based on your
current situation and how to plan accordingly. One of the best feelings you can
have is knowing that your financial independence is secure.</p>

<p>Contact SIG & Associates today to see how Financial Planning can help achieve your goals.</p>

<p><small><i>Investing involves market risk, including possible loss of principal, and there
is no guarantee that investment objectives will be achieved.</i></small></p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  annuities: {
    header: 'Annuities',
    body: `<div class="title-sm">Keep Your Financial Resources Protected</div>

<p>SIG & Associates understands the value of saving for and investing in your future.
If you’re like many Americans, you work diligently each day and take the right steps to ensure
that you’ll be supported with a comfortable income after you retire. That’s why it’s smart
to have the right coverage options under your retirement plan because in some cases,
you can actually outlive your income.</p>
<p>The last thing you’ll want to experience as a retiree is a
loss of your financial resources. With an Annuity from SIG & Associates,
you can ensure that your finances are covered – for a healthy and happy retirement.
Annuities are essentially investments that guarantee a steady income stream.
Based on your plan, you can receive money either on a set schedule or in a lump sum.</p>

<div class="title-sm">Keep Your Financial Resources Protected</div>

<p>SIG & Associates can offer two types of Annuities: Deferred and Immediate Annuities.</p>
<p>Deferred Annuities are investments that you make either over a period of time or all at once.
Since these Annuities are tax-deferred, you only have to start paying taxes upon withdrawal.
Deferred Annuities are either fixed or variable, meaning your payout is either a fixed sum
or an amount in accordance to the performance of the market/group of investments.</p>

<p>Immediate Annuities are payments that you can receive right after you make your investment.
This type of Annuity is typically for those around the retirement age who want to
secure their financial future. Like Deferred Annuities, you only pay taxes upon withdrawal.</p>

<div class="title-sm">Understand Your Investments</div>

<p>An annuity is a long-term, tax-deferred investment designed for retirement.
With an annuity, you can create a fixed or variable stream of income.
The annuity’s value and growth will vary based on how the investments
you choose to fund the annuity (underlying investments) perform.</p>

<p>Just like other types of investments, an annuity has limitations.
If you take your money out early, you may have to pay fees called surrender charges.
You’ll have to pay income tax on the withdrawal, and if you’re not yet 59½ years old,
you may also have to pay a 10% tax penalty. If you do take an early withdrawal,
it will reduce both the death benefit your beneficiaries receive and the cash value of the annuity.</p>

<p>An annuity is sold by an insurance company, and the annuity’s guarantees and
protections are subject to that company’s ability to pay for them. However,
this doesn’t apply to the underlying investments. The underlying investments
are subject to market risk, so you could end up with less money than you invested.</p>

<p>An annuity is sold by prospectus, a document that describes the annuity’s
objectives, risks, fees and charges. The cost of an annuity often includes
mortality and expense charges, administrative fees, contract fees and the
expense of the underlying investments. There are prospectuses for the annuity and
the underlying investments that fund the annuity. It may take some time,
but you should read the prospectuses carefully before investing.</p>

<p>It’s important to discuss your options with a specialist at
SIG & Associates who is committed to helping you make the right decisions.</p>

<p><small><i>Before investing, understand that annuities are not insured by the FDIC, NCUSIF or any other federal
government agency, and are not deposits or obligations of, guaranteed by, or insured by the depository
institution where offered or any of affiliates. Annuities that involve investment risk may lose value.
Guarantees and protections are subject to the claims paying ability of the issuing insurance company.</i></small></p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  retirement: {
    header: 'Retirement Plans',
    body: `<div class="title-sm">Small Business Retirement Plans</div>

<p>Offering a retirement plan for your employees could be one of the best things
you'll do for your small business. The benefits aren't just in the future, either—as
pointed out by the Department of Labor, starting a retirement plan offers immediate tax
benefits in the form of deductibles, deferred taxation, and tax-free growth. Small employers
can also usually take advantage of available tax credits that help offset the creation and
administration of their plan, making it both easy and affordable to get started.</p>

<div class="title-sm">Types of Small Business Retirement Plans</div>
<p>If you're going to start offering small business retirement plans, you need to decide what
type of plan(s) are actually going to be offered. There are a few different choices,
each with their own advantages for different types of business owners.</p>

<div class="title-sm">401(k) Plans</div>
<p>A 401(k) plan—named after its designation by the IRS—is a special type of retirement account
that allows employees to contribute some of their earnings into a savings plan.
The three main forms of 401(k) plans available are Safe Harbor, Automatic Enrollment, and Traditional,
all of which have important differences for small businesses. We encourage talking to a certified
financial professional prior to selecting a plan in order to ensure that it's
right for your company's needs, both now and in the future.</p>

<p><small><i>*Federal income tax laws are complex and subject to change. Neither Nationwide
nor its representatives give legal or tax advice. Please consult your attorney or
tax advisor for answers to specific questions. </i></small></p>

<div class="title-sm">Profit Sharing Plans</div>
<p>If your company's income is variable, you can opt for what's known as a "profit sharing plan."
These plans accept contributions at the discretion of employers, and typically do not require a
certain amount of contributions each year. This is especially useful for startups, who may not have
funds to spare as they work to establish themselves and deal with the challenges of creating a new business.</p>

<p>While all plans are required to file a Form 5500 each year to report their performance,
the plans are accepted for businesses of any size and can even be used by companies that have other
retirement plans in place. A SIG & Associates agents would be happy to discuss these and other options with you.</p>

<ul>
<li><a href="http://www.dol.gov/ebsa/publications/choosing.html" target="_blank"><b>"Choosing a Retirement Solution for Your Small Business."</b>
Accessed April 12, 2016. http://www.dol.gov/ebsa/publications/choosing.html</a></li>
<li><a href="https://www.irs.gov/Retirement-Plans/Form-5500-Corner" target="_blank"><b>"Form 5500 Corner."</b>
Accessed April 12, 2016. https://www.irs.gov/Retirement-Plans/Form-5500-Corner</a></li>
</ul>

<p><small><i>Guarantees and protections are subject to the claims paying ability of the issuing insurance company.</i></small></p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  }
}



// WEBPACK FOOTER //
// ./src/helpers/financialHelper.js